import React, {useState} from 'react';
import {Button, Grid, List} from '@mui/material';
import {
  newCategory,
  newImage,
  newMiniTool,
  newParagraph,
  newPdf,
  newSubTopic,
  newTopic,
  newVideo,
} from '../helper/contentObjectCreator';

type Props = {
  setDisplayPocToolContent: Function;
  displayPocToolContent: any[];
};

export default function NewItemsList(props: Props) {
  //This component manages the creation of new items (minitools, categories, contents...) in the displayPocToolContent.

  const {displayPocToolContent, setDisplayPocToolContent} = props;
  const [isListShown, setIsListShown] = useState(false);

  const addMiniTool = () => {
    setDisplayPocToolContent([...displayPocToolContent, newMiniTool()]);
  };
  const addCategory = () => {
    setDisplayPocToolContent([...displayPocToolContent, newCategory()]);
  };
  const addTopic = () => {
    setDisplayPocToolContent([...displayPocToolContent, newTopic()]);
  };
  const addSubtopic = () => {
    setDisplayPocToolContent([...displayPocToolContent, newSubTopic()]);
  };
  const addParagraph = () => {
    setDisplayPocToolContent([
      ...displayPocToolContent,
      newParagraph(displayPocToolContent.length),
    ]);
  };
  const addImage = () => {
    setDisplayPocToolContent([
      ...displayPocToolContent,
      newImage(displayPocToolContent.length),
    ]);
  };
  const addVideo = () => {
    setDisplayPocToolContent([
      ...displayPocToolContent,
      newVideo(displayPocToolContent.length),
    ]);
  };
  const addPDf = () => {
    setDisplayPocToolContent([
      ...displayPocToolContent,
      newPdf(displayPocToolContent.length),
    ]);
  };

  return (
    <Grid style={styles.addContentContainer}>
      <Button
        style={{width: '100%'}}
        variant="contained"
        onClick={() => setIsListShown(!isListShown)}>
        Add content
      </Button>
      <List
        style={{
          ...styles.list,
          ...{display: isListShown ? 'flex' : 'none'},
        }}
        aria-label="mailbox folders">
        <Button
          variant="text"
          style={styles.minitoolButton}
          onClick={addMiniTool}>
          Mini Tool
        </Button>
        <Button
          variant="text"
          style={styles.categoryButton}
          onClick={addCategory}>
          Category
        </Button>
        <Button variant="text" onClick={addTopic} style={styles.topicButton}>
          Topic
        </Button>
        <Button
          variant="text"
          onClick={addSubtopic}
          style={styles.subTopicButton}>
          Subtopic
        </Button>
        <Button
          variant="text"
          onClick={addParagraph}
          style={styles.contentButton}>
          Paragraph
        </Button>
        <Button variant="text" onClick={addImage} style={styles.contentButton}>
          Image
        </Button>
        <Button variant="text" onClick={addVideo} style={styles.contentButton}>
          Video
        </Button>
        <Button variant="text" onClick={addPDf} style={styles.contentButton}>
          PDF
        </Button>
      </List>
    </Grid>
  );
}

const styles = {
  container: {
    display: 'flex',
    paddingTop: 30,
    flexDirection: 'column',
  },
  contentContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  contentButton: {
    color: '#00A010',
    width: '100%',
  },
  addContentContainer: {
    width: 180,
    alignSelf: 'center',
    marginBottom: 80,
  },
  subTopicButton: {
    color: '#333333',
    width: '100%',
  },
  topicButton: {
    color: '#0C7CFF',
    width: '100%',
  },
  categoryButton: {
    color: '#FF5C00',
    width: '100%',
  },
  minitoolButton: {
    color: '#800080',
    width: '100%',
  },
  list: {
    width: '100%',
    maxWidth: 360,
    flexDirection: 'column',
    border: '1px solid #1976D2',
    borderTop: 0,
  },
};
